import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-slate-50 pt-24 pb-12 px-6">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-3xl shadow-xl">
        <h1 className="text-3xl font-extrabold text-slate-900 mb-6">Terms and Conditions</h1>
        
        <p className="text-slate-600 mb-4">Welcome to KaamSetu!</p>
        <p className="text-slate-600 mb-4">
          These terms and conditions outline the rules and regulations for the use of KaamSetu's Website, located at www.indlabour.xyz.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">1. Acceptance of Terms</h2>
        <p className="text-slate-600 mb-4">
          By accessing this website we assume you accept these terms and conditions. Do not continue to use KaamSetu if you do not agree to take all of the terms and conditions stated on this page.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">2. User Responsibilities</h2>
        <p className="text-slate-600 mb-4">
          You agree to use this website only for lawful purposes. Workers must provide accurate information about their skills and identity. Customers must treat workers with respect and pay fairly as agreed.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">3. Disclaimer</h2>
        <p className="text-slate-600 mb-4">
          KaamSetu is a platform to connect workers with customers. We are not responsible for the quality of work performed or any disputes that arise between the worker and the customer. Users are advised to verify details before hiring.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">4. Termination</h2>
        <p className="text-slate-600 mb-4">
          We may terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">5. Changes to Terms</h2>
        <p className="text-slate-600 mb-4">
           We reserve the right to modify these terms at any time. Please review this page periodically for changes.
        </p>

      </div>
    </div>
  );
};

export default Terms;